export default {
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
};
